<h2 mat-dialog-title>Edit Model Tree</h2>
<div mat-dialog-content class="views-layout">
    @if (!isLoading) {
        @for (view of views; track $index) {
            <div class="view-container justify-content-between align-items-center">
                <button mat-button (click)="onSelectView(view)">
                    <p class="mb-0">
                        {{view.file_name}} [{{getViewServiceName(view)}}]
                    </p>
                </button>
            </div>
        }
    }@else{
        <div class="h-100 d-flex justify-content-center align-items-center loading">
            <mat-progress-spinner mode="indeterminate" class="bright-spinner"> </mat-progress-spinner>
        </div>
    }
    <div class="actions">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
  </div>
</div>